// import { MAX_WIDTH } from "@/constant/Constant";
import useWindowSize from "@/hook/useWindowSize";
import LogoHeader from "@/pages/components/Headers/LogoHeader";
import { t } from 'i18next';
import { useNavigate } from "react-router-dom";
import useSettings from "@/hook/useSettings";
// import RouteConstant from "@/constant/RouteConstant";
import { Box, Grid, styled } from "@mui/material";
import Icon1 from "../../../assets/sonic/welcome-icon-1.svg"
import Icon2 from "../../../assets/sonic/welcome-icon-2.svg"
import Icon3 from "../../../assets/sonic/welcome-icon-3.svg"
import Icon4 from "../../../assets/sonic/welcome-icon-4.svg"
import styles from "./css/promoview.module.less"

const StyledBox = styled(Box)(({theme, width}) => {
  // let backgroundPositionY;
  // if (width <= 450) {
  //   backgroundPositionY = '-60px !important';
  // } else if (width > 450 && width <= MAX_WIDTH) {
  //   backgroundPositionY = '-40vw !important';
  // } else {
  //   backgroundPositionY = '-160px !important';
  // }

  return {
    // background: 'url(/images/bind-bg.png) no-repeat',
    // backgroundSize: '100% auto',
    // backgroundPositionY: backgroundPositionY,
    minHeight: '100vh',
    position: 'relative',
    width: '100%',
  }
  //-40vw !important  
})
const StyledCategoryBox = styled(Box)(({theme}) => ({
  borderRadius: "16px",
  border: "0.5px solid rgba(13, 15, 14, 0.00)",
  background: "rgba(14, 16, 15, 0.80)",
  backdropFilter:"blur(6px)",
  margin:"0 16px",
  marginTop:"12px",
  
  padding:"24px 12px 16px",
  '.MuiGrid-item': {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'start',
    alignItems: 'center',
  },
  'img': {
    width: '60px',
  },
  '.title': {
    fontSize: '12px',
    fontWeight: 400,
    padding: '6px 0',
    maxWidth: '100px',
    textAlign: 'center',
  }
}))

const StyledCardsBox = styled(Box)(({theme}) => ({
  borderRadius: "16px",
  border: "0.5px solid rgba(13, 15, 14, 0.00)",
  background: "rgba(14, 16, 15, 0.80)",
  backdropFilter:"blur(6px)",
  margin:"0 16px",
  marginTop:"12px",
  padding:"12px 24px",
  marginBottom:"30px",
  '.MuiGrid-item': {
    'img': {
      width: '70px',
    },

    '.item-title': {
      textAlign: 'center',
      fontSize: '14px',
      fontWeight: 500,
      padding: '12px 0',
    },
    '.item-des': {
      textAlign: 'center',
      fontSize: '12px',
      fontWeight: 400,
      color: theme.palette.text.secondary,
    }
  },
}))


function PromoView({onGoTo}) {
  const {
    width,
  } = useWindowSize();
  const { settings } = useSettings();
  const renderCosts=()=>{
    return settings.lang=="en"?<span>Ultra-low<br/>costs</span>:t('ultra_low_trans_costs')
  }
  return (
    <StyledBox width={width}>
      <LogoHeader />
      <div className={styles.cardContent}>
          <div className={styles.title}>
          Pay With Crypto
          </div>
          <div className={styles.subTitle}>
          Spend your tokens on Sonic with your personal debit card.
          </div>
          <div className={styles.linkBtn} onClick={()=>{
              onGoTo()
            }}>
            Order card
          </div>
          
      </div>
      {/* 卡片展示 */}
      <div className={styles.cardImg}>
        <img src="/images/sonic/sonic-card.png" alt="" />
      </div>
      <StyledCategoryBox>
        <Grid container>
          <Grid item xs={4}>
            <img src={'/images/bind-icon-1.png'} />
            <div className="title">{t('spend_your_crypto_like_fiat')}</div>
          </Grid>
          <Grid item xs={4}>
            <img src={'/images/bind-icon-2.png'} />
            <div className="title">{t('use_globally_across_borders')}</div>
          </Grid>
          <Grid item xs={4}>
            <img src={'/images/bind-icon-3.png'} />
            <div className="title">
              {
              renderCosts()
              
              }
              </div>
          </Grid>
        </Grid>
      </StyledCategoryBox>

      <StyledCardsBox>
        <div className={styles.cardIconTitle}>
          <div className={styles.text}>
            {t('seamless_and_secure')}
          </div>
        </div>
        <div className={styles.cardIcon}>
          <Grid container>
            <Grid item xs={6}>
              <div className={`${styles.iconItem} ${styles.iconItem1}`}>
                <img src={Icon1} />
                <div className="item-title" style={{
                  whiteSpace:`${settings.lang=="en"?"nowrap":"normal"}`
                }}>{t('two_factor_verification')}</div>
                <div className="item-des">{t('two_factor_verification_des')}</div>
              </div>
            </Grid>
            <Grid item xs={6}>
              <div className={`${styles.iconItem} ${styles.iconItem2}`}>
                <img src={Icon2} />
                <div className="item-title">{t('safety_pin')}</div>
                <div className="item-des">{t('safety_pin_des')}</div>
              </div>
            </Grid>
            <Grid item xs={6}>
              <div className={`${styles.iconItem} ${styles.iconItem3}`}>
                <img src={Icon3} />
                <div className="item-title">{t('trans_3ds_verification')}</div>
                <div className="item-des">{t('trans_3ds_verification_des')}</div>
              </div>
            </Grid>
            <Grid item xs={6}>
              <div className={`${styles.iconItem} ${styles.iconItem4}`}>
                <img src={Icon4} />
                <div className="item-title">{t('additional_security')}</div>
                <div className="item-des">{t('additional_security_des')}</div>
              </div>
            </Grid>
          </Grid>
        </div>

       
      </StyledCardsBox>
    </StyledBox>
  );
}

export default PromoView;
